import { Injectable } from '@angular/core'
import { Router } from '@angular/router'

export enum FolderOverviewTab {
  FOLDER = 'folder',
  ACTIVITY = 'activity',
  DETAILS = 'details',
  RETAINED_TEAMS = 'retained-teams',
  RETAINER_BREAKDOWN = 'retainer-breakdown',
}

@Injectable({ providedIn: 'root' })
export class FolderOverviewNavigationService {
  currentTab: FolderOverviewTab

  constructor(private router: Router) {}

  setTab(tab?: FolderOverviewTab) {
    this.currentTab = tab || FolderOverviewTab.FOLDER
    this.router.navigate([], { queryParams: tab ? { tab } : null })
  }
}
